import { useEffect, useRef } from 'react';
import { Modal } from '@engie-group/fluid-design-system';

/**
 * Initializes Bootstrap modal and handles scroll locking + onHide callback.
 */
export default function useModalLifecycle(
    dataTarget: string,
    onHide?: () => void
) {
    const onHideRef = useRef(onHide);
    useEffect(() => {
        onHideRef.current = onHide;
    });

    useEffect(() => {
        Modal.init();
    }, []);

    useEffect(() => {
        const modalElement = document.getElementById(dataTarget);
        if (!modalElement) {
            return undefined;
        }

        const observer = new MutationObserver(() => {
            const isModalOpen = modalElement.classList.contains('show');
            const scrollbarWidth =
                window.innerWidth - document.documentElement.clientWidth;

            if (isModalOpen) {
                document.body.style.overflow = 'hidden';
                if (scrollbarWidth > 0) {
                    document.body.style.paddingRight = `${scrollbarWidth}px`;
                }
            } else {
                document.body.style.overflow = '';
                document.body.style.paddingRight = '';
                if (onHideRef.current) {
                    onHideRef.current();
                }
            }
        });

        observer.observe(modalElement, {
            attributes: true,
            attributeFilter: ['class'],
        });

        return () => {
            observer.disconnect();
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        };
    }, [dataTarget]);
}
